<template>
    <div class="mx-3"> 
        <inbox-assign-modal></inbox-assign-modal> 
        <delete-confirmation name="document" @confirm="deleteDocument"></delete-confirmation>

        <div class="row border-bottom mx-1">
            <div class="h2">Inbound Faxes</div>
        </div>        
        <div v-if="documents.length" class="table-responsive"> 
            <table class="table table-striped table-sm">
                <thead>
                    <tr>
                        <th>File Name</th>
                        <th>Client</th>
                        <th class="fit">Received</th>
                        <th class="fit"></th>
                    </tr>            
                </thead>
                <tbody v-if="documents.length > 0">
                    <tr v-for="document in documents" :key="document.id">
                        <td>
                            <span v-show="document.read_at" class="cursor-pointer" data-toggle="popover" data-placement="left" :data-content="getReadContent(document)">
                                <i class="far fa-envelope-open mr-3 text-muted"></i>
                            </span>
                            <span v-show="!document.read_at">
                                <i class="far fa-envelope mr-3 text-muted"></i>
                            </span>
                            <a :href="'/inbox/documents/' + document.id" target="_blank"><span v-text="document.filename"></span></a>
                        </td>
                        <td v-text="document.client_name"></td>
                        <td class="fit">{{ document.created_at | localizeTime('YYYY-MM-DD HH:mm:ss') }}</td>
                        <td class="fit px-3">
                            <a href="javascript:void(0)" @click="onAssign(document.id, document.client_id)" title="Link Document to Claim"><i class="fas fa-link fa-lg"></i></a>
                            <a v-if="allowDelete" href="javascript:void(0)" class="ml-3" @click="confirmDelete(document.id)" title="Delete Document"><i class="fas fa-trash-alt fa-lg"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="d-flex">
                <nav v-if="pageCount > 1" aria-label="Page navigation">
                    <ul class="pagination">
                        <li v-bind:class="['page-item', { 'disabled' : currentPage == 1 }]">
                            <a class="page-link" href="#" @click="first()">
                                <span id="first-page"><i class="fas fa-step-backward fa-xs chev-pos"></i></span>
                            </a>
                        </li>                         
                        <li v-bind:class="['page-item', { 'disabled' : currentPage == 1 }]">
                            <a class="page-link" href="#" @click="previous()">
                                <span id="previous"><i class="fas fa-chevron-left fa-xs chev-pos"></i><i class="fas fa-chevron-left fa-xs mr-1 chev-pos"></i>Previous</span>
                            </a>
                        </li>
                        <li v-bind:class="['page-item', { 'disabled' : currentPage == pageCount }]">
                            <a class="page-link" href="#" @click="next()">
                                <span id="next">Next<i class="fas fa-chevron-right fa-xs ml-2 chev-pos"></i><i class="fas fa-chevron-right fa-xs chev-pos"></i></span>
                            </a>
                        </li>
                        <li v-bind:class="['page-item', { 'disabled' : currentPage == pageCount }]">
                            <a class="page-link" href="#" @click="last()">
                                <span id="first-page"><i class="fas fa-step-forward fa-xs chev-pos"></i></span>
                            </a>
                        </li>                         
                    </ul>
                </nav>
                <div class="ml-auto"> Page {{ currentPage }} of {{ pageCount }}</div>
            </div>

        </div>
        <div v-else-if="isLoading" class="pt-3">            
            <h3 class="text-muted text-center"><i class="fas fa-spinner fa-lg fa-spin align-middle"></i> Loading...</h3>
        </div>        
        <div v-else class="pt-3">
            <h2 class="text-muted text-center">Your inbox is empty.</h2>
        </div>        
    </div>      
</template>

<script>
    import InboxAssignModal from './InboxAssignComponent.vue';

    export default {
        components: {
            InboxAssignModal
        },
        props: {
            allowDelete: false,
        },         
        data() {
            return {
                documents: [],
                currentPage: 1,
                pageCount: 0,
                isLoading: true
            };
        },   
        methods: {
            refresh: function() {
                this.isLoading = true;
                axios.get('/ajax/inbox/documents', {
                    params: {
                        'page': this.currentPage - 1
                    }                  
                })
                .then(response => { 
                    this.documents = response.data.documents;
                    this.pageCount = response.data.page_count;
                    this.isLoading = false;

                    // handle the case where the last document on the current page was assigned
                    if (!this.documents.length && this.currentPage > 1) {
                        this.currentPage--;
                        this.refresh();
                    }
                    
                    // enable popover tooltips
                    this.$nextTick(() => {
                        $('[data-toggle="tooltip"]').tooltip();
                        $('[data-toggle="popover"]').popover();                        
                    });                      
                })
                .catch(error => {
                    this.isLoading = false;
                });
            },
            first: function () {
                if (this.currentPage > 1) {
                    this.currentPage = 1;
                    this.refresh();
                }
            },            
            previous: function() {
                if (this.currentPage > 0) {
                    this.currentPage--;
                    this.refresh();
                }
            },
            next: function() {
                if (this.currentPage < this.pageCount) {
                    this.currentPage++;
                    this.refresh();
                }
            },
            last: function () {
                if (this.currentPage < this.pageCount) {
                    this.currentPage = this.pageCount;
                    this.refresh();
                }
            },                        
            onAssign: function(documentId, clientId) {
                let data = {
                    documentId: documentId,
                    clientId: clientId,
                }
                eventHub.$emit('show-inbox-assign', data);
            },
            confirmDelete: function (id) {
                eventHub.$emit('show-delete-document-confirmation', id);
            },
            deleteDocument: function (id) {
                if (id > 0) {
                    axios.delete('/ajax/inbox/documents/' + id)
                        .then(response => {
                            // nothing to do; server side event will cause refresh
                        })
                        .catch(error => {
                            let title = error.response.data.title;
                            let message = error.response.data.message;
                            let level = error.response.data.level;
                            toastr[level](message, title, {timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true});
                        });
                }
            },
            getReadContent: function (doc) {
                return 'Read by ' + doc.read_by + ' on ' +  this.$options.filters.localizeTime(doc.read_at, 'YYYY-MM-DD HH:mm:ss');
            }                 
        },
        created() {
            this.refresh();
            eventHub.$on('inbox-refresh', this.refresh);                        
        },
        beforeDestroy() {
            eventHub.$off('inbox-refresh');
        },
    }
</script>

<style>

</style>


